import React, { Component, Fragment } from 'react'
import { Labeled } from 'react-admin'
import _ from 'lodash'

import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';
import DetailIcon from '@material-ui/icons/Search';
import Grid from '@material-ui/core/Grid'
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { withStyles } from '@material-ui/core/styles'

import { DatasheetField, renderModelFields } from '../../Fields'


const collapseComponent = (props) => (
    <tr>
        <td colSpan={4}> {/* put the number of col of your table in this field */}
            <div className={props.className}>
                {props.children}
            </div>
        </td>
    </tr>
)

const styles = {
    form: {
        margin: '20px'
    },
    button: {
        icon: {
            marginRight: '10px'
        }
    },
    title : {
        padding: '0 0 20px 20px',
        borderBottom: '1px solid #B5B5B7',
        alignItems: 'center',
        color : '#64676C',
        fontSize : 25,
        fontWeight: 600,
        '& svg' : {
            color : '#33C2D5',
            paddingRight : 10,
            fontSize: 18,
        }
    },
    subTitle : {
        marginTop : 30,
        padding: '0 0 20px 20px',
        display: 'flex',
        alignItems: 'center',
        color : '#64676C',
        fontSize : 18,
        fontWeight: 600,
        '& svg' : {
            color : '#33C2D5',
            paddingRight : 10,
            fontSize: 18,
        }
    },
    thead : {
        '& tr th' : {
            color: '#019EAC',
            fontSize: '0.85rem',
            fontWeight: 600,
            borderBottom : 'none',
            backgroundColor : '#EFEEEF',
        }
    },
    tbody : {
        '& tr td' : {
            color : '#676767',
            fontSize: '0.85rem',
        },
        '& tr td:first-child' : {
            fontWeight: 500,
        }
    },
    elementGrid :{
        marginBottom: 10,
        borderBottom: '4px solid #63CAD4',
        minHeight: 95,
        padding: 10,
    },
    label : {
        color : '#3C3E3F',
        fontWeight: 600,
        textTransform: 'capitalize',
        fontSize: 18,
    },
    value : {
        '& span' : {
            color : '#696B6C'
        }
    }
}

class HistoryEntry extends Component {
    state = {
        isOpen: false
    }

    handleCollapse = () => {
        this.setState({ isOpen: !this.state.isOpen })
    }

    renderField = (field, data) => {
        const { classes } = this.props
        return field ? (
            <Grid item xs={12} lg={4} key={field.props.label}>
              <div className={classes.elementGrid}>
                <Labeled
                    record={data}
                    basePath={""}
                    label={field.props.label}
                    source={field.props.source}
                    disabled={false}
                    classes={{label : classes.label, value : classes.value}}
                >
                    {field}
                </Labeled>
              </div>
            </Grid>
        ) : null
    }

    render() {
        const { entry, permissions, classes } = this.props;
        const date = new Date(entry.date)

        if (permissions === null) {
            return null
        }
        const fieldComponents = renderModelFields(entry.shape.fields, permissions)

        return (
            <Fragment>
                <TableRow>
                    <TableCell>{entry.id}</TableCell>
                    <TableCell>{date.toLocaleString()}</TableCell>
                    {!["coordinado", "guest"].includes(permissions.role)
                      && <TableCell>{entry.user || "---"}</TableCell>}
                    <TableCell>
                        <Button color="primary" onClick={this.handleCollapse}>
                            <DetailIcon style={{ marginRight: '5px' }}/> Ver Detalle
                        </Button>
                    </TableCell>
                </TableRow>
                <Collapse
                    in={this.state.isOpen}
                    timeout="auto"
                    component={collapseComponent}
                    unmountOnExit
                >
                    <Grid container spacing={16} className={classes.collapsedContent}>
                        {_.map(fieldComponents, field => this.renderField(field, entry.data))}
                        {!_.isEmpty(entry.shape.schema) && (
                            <Grid item xs={12}>
                                <DatasheetField
                                    record={entry.data}
                                    schema={entry.shape.schema}
                                />
                            </Grid>
                        )}
                    </Grid>
                </Collapse>
            </Fragment>
        )
    }
}

export default withStyles(styles)(HistoryEntry)
